import React from "react";
import { GenericPage } from "../../../../../pages";
import { profilesRoute } from "./options-profile.route";
import { usersRoute } from "./options-user.route";
import { systemRoute } from "./options-system.route";
import { migrationsRoute } from "./options-migrations.route";
import { cronsRoute } from "./options-crons.route";
import { backupsRoute } from "./options-backup.route";
import { storageFileRoutes } from "./options-file.route";

export const optionsRoute = [
  {
    path: "backups",
    element: <GenericPage />,
    children: backupsRoute,
  },
  {
    path: "crons",
    element: <GenericPage />,
    children: cronsRoute,
  },
  {
    path: "profiles",
    element: <GenericPage />,
    children: profilesRoute,
  },
  {
    path: "files",
    element: <GenericPage />,
    children: storageFileRoutes,
  },
  {
    path: "users",
    element: <GenericPage />,
    children: usersRoute,
  },
  {
    path: "migrations",
    element: <GenericPage />,
    children: migrationsRoute,
  },
  {
    path: "system",
    element: <GenericPage />,
    children: systemRoute,
  },
];
